export const alignment = <const>['start', 'end'];
export type Alignment = typeof alignment[number];

export const buttonType = <const>['button', 'reset', 'submit'];
export type ButtonType = typeof buttonType[number];

/**
 * by constructing the FontSize type from the fontSize array, we still get the benefits of a Type while
 * also having a fontSize const available at runtime
 * https://stackoverflow.com/a/64174790/981556
 */
export const fontSize = <const>['2xs', 'xs', 'sm', 'md', 'base', 'lg', 'xl', '2xl', '3xl', '4xl', '5xl', '6xl', '7xl'];
export type FontSize = typeof fontSize[number];

export const status = <const>['idle', 'invalid', 'valid'];
export type Status = typeof status[number];

export const strokeWidth = <const>['regular', 'medium', 'semibold', 'bold'];
export type StrokeWidth = typeof strokeWidth[number];

export const target = <const>['_blank', '_parent', '_self', '_top'];
export type Target = typeof target[number];

export const width = <const>['auto', 'full'];
export type Width = typeof width[number];
